import { useState } from "react";
import { Title, Description, InputText, ButtonPrimary } from "../../../../common"
import { FormCreateSession, ToggleRow, ToggleLabel, ToggleSwitch } from "./style";

export interface CreateSessionFormProps {
    load: boolean;
    onSubmit: (name: string, captureReactionTime: boolean) => Promise<void>
}

export const CreateSessionForm: React.FC<CreateSessionFormProps> = ({ load, onSubmit }) => {
    const [name, setName] = useState<string>("");
    const [captureReactionTime, setCaptureReactionTime] = useState<boolean>(false);

    const handleSubmit = () => onSubmit(name, captureReactionTime);

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === "Enter" && name) {
            e.preventDefault();
            handleSubmit();
        }
    };

    return (
        <>
            <Title>Sessão de treino</Title>
            {!load &&
                <>
                    <Description align="center">
                        Defina um nome para a sessão
                    </Description>
                    <FormCreateSession>
                        <InputText
                            label="Nome da sessão"
                            placeholder="ex: Sessão de treino aluno 1"
                            value={name}
                            onChange={(e: any) => setName(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                        <ToggleRow>
                            <ToggleLabel>Capturar tempo de reação?</ToggleLabel>
                            <ToggleSwitch
                                checked={captureReactionTime}
                                onChange={(e) => setCaptureReactionTime(e.target.checked)}
                            />
                        </ToggleRow>
                        <ButtonPrimary
                            disabled={!name}
                            loading={load}
                            margintop="20px"
                            marginbottom="30px"
                            onClick={handleSubmit}
                        >
                            Criar e continuar
                        </ButtonPrimary>
                    </FormCreateSession>

                </>
            }
        </>
    )
}
